import script from "./ModalVerLista.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalVerLista.vue?vue&type=script&setup=true&lang=ts"

import "./ModalVerLista.vue?vue&type=style&index=0&id=4c745996&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c745996"]])

export default __exports__